import React, { useState, useEffect } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";

import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
// import { CSVLink } from "react-csv";

// const { SearchBar } = Search;

import { Form, Row, Col } from "react-bootstrap";

import FarmerMasterService from "../../services/farmermaster.service";
import authService from "../../services/auth.service";
import TimeregService from "../../services/timereg.service";

// import moment from "moment/min/moment-with-locales";
import moment from "moment";
import "moment/locale/th";

moment.locale("th");

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";
const { ExportCSVButton } = CSVExport;

import "./Farmermaster.css";

function Farmermasterlist() {
  // const [loading, setLoading] = useState(false);
  const [loadAlert, setLoadAlert] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [timeregSelect, setTimeregSelect] = useState(0);
  const [timeregList, setTimeregList] = useState([]);

  const user = authService.getCurrentUser();

  const getTimeRegList = () => {
    TimeregService.getTimereglist(user.user.user_reg)
      .then((response) => {
        setTimeregList(response.data.data);
      })
      .catch((err) => {
        console.log("fetch timereg List Error :" + err);
      });
  };

  const handleTimeregChange = (e) => {
    setTimeregSelect(e.target.value);
    getData(user.user.user_reg, e.target.value);
  };

  useEffect(() => {
    getTimeRegList();
  }, []);

  const getData = (reg_id, timereg_id) => {
    setLoadAlert(true);
    FarmerMasterService.getFarmerMaster(reg_id, timereg_id)
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoadAlert(false);
      });
  };

  // const ActionsEdit = (row) => {
  //   if (row.row.approve_status == "อนุมัติ") {
  //     return <>-</>;
  //   } else {
  //     return (
  //       <>
  //         <i
  //           className="bi bi-pencil custom-icon-table"
  //           onClick={() => clickEdit(row.row)}
  //         ></i>
  //         <i
  //           className="bi bi-upload custom-icon-table"
  //           style={{ color: "green" }}
  //           onClick={() => clickUpload(row.row)}
  //         ></i>
  //         <i
  //           className="bi bi-trash custom-icon-table"
  //           style={{ color: "red" }}
  //           onClick={() => clickDelete(row.row)}
  //         ></i>
  //       </>
  //     );
  //   }
  // };

  // const actionsEdittFormatter = (cell, row) => {
  //   return <ActionsEdit row={row} />;
  // };

  const columns = [
    {
      text: "masterId",
      dataField: "masterid",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
      csvExport: false,
    },
    {
      text: "masterIDCard",
      dataField: "masteridcard",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
    },
    {
      text: "ชื่อ-สกุล",
      dataField: "mastername",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "20%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "left",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "หน. กลุ่ม",
      dataField: "status_text",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "อนุมัติ",
      dataField: "approve_status",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "8%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      // style: {
      //   wordBreak: "break-word",
      // },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },

    {
      text: "อนุมัติโดย",
      dataField: "approve_name",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "8%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },

    {
      text: "รหัส หน. กลุ่ม",
      dataField: "farmer_card",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "8%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "วันที่เริ่ม",
      dataField: "start_date",
      sort: true,
      editable: false,
      formatter: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "9%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "วันที่สิ้นสุด",
      dataField: "end_date",
      sort: true,
      editable: false,
      formatter: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "9%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    // {
    //   text: "แก้ไข",
    //   dataField: "edit",
    //   isDummyField: true,
    //   editable: false,
    //   formatter: actionsEdittFormatter,
    //   headerStyle: () => {
    //     return { textAlign: "center", width: "13%" };
    //   },
    //   style: {
    //     wordBreak: "break-word",
    //     textAlign: "center",
    //   },
    // },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  // if (loading) return <div id="search-results">Loading....</div>;
  if (error) return `Error :${error}`;

  return (
    <div>
      {loadAlert ? <LoadingAlert /> : ""}
      <ToolkitProvider
        bootstrap4
        keyField="masterId"
        data={data}
        columns={columns}
        search
        exportCSV={{
          fileName: "ข้อมูลการจดทะเบียน หน.กลุ่ม.csv", // "ข้อมูลสมาชิก_" + {cell} + ".csv",
          separator: ",",
          ignoreHeader: false,
          noAutoBOM: false,
          blobType: "text/plain;charset=utf-8",
          onlyExportFiltered: true,
          exportAll: false,
        }}
      >
        {(prop) => (
          <React.Fragment>
            <Row>
              <Col md={8}>
                <ExportCSVButton
                  {...prop.csvProps}
                  style={{
                    padding: ".375rem .75rem",
                    fontSize: "1rem",
                    // float: "right",
                  }}
                >
                  <i className="bi bi-download"></i>
                </ExportCSVButton>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Select
                    name="approve_status"
                    value={timeregSelect}
                    onChange={handleTimeregChange}
                  >
                    <option value="0">เลือกรอบที่จดทะเบียน</option>
                    {timeregList.map((a) => (
                      <option key={a.timereg_id} value={a.timereg_id}>
                        {a.timereg_desc}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <hr />
            <BootstrapTable
              // bootstrap4
              // keyField="farmer_id"
              // columns={columns}
              // data={data}
              pagination={pagination}
              //   cellEdit={cellEditFactory({
              //     mode: "click",
              //     blurToSave: true,
              //     afterSaveCell,
              //   })}
              filter={filterFactory()}
              // loading={true}
              {...prop.baseProps}
              // cellEdit={cellEditFactory({
              //   mode: "click",
              //   blurToSave: true,
              //   afterSaveCell: handleChange,
              //   beforeSaveCell: beforeSaveCell,
              // })}
            />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
}

export default Farmermasterlist;
